import React from 'react';
import {
  IndicatorService,
  IndicatorOptions as _IndicatorOptions,
  setLoading as _setLoading,
} from './indicator';
import {
  ToastService,
  ToastOptions as _ToastOptions,
  ToastMessage as _ToastMessage,
} from './toast';
import {
  VersionControlService,
  VersionControlOptions as _VersionControlOptions,
  enableControlVersion as _enableControlVersion,
  controlVersion as _controlVersion
} from './versioning';

export type IndicatorOptions = _IndicatorOptions;
export type ToastOptions = _ToastOptions;
export type VersionControlOptions = _VersionControlOptions;

export const SetLoading = _setLoading;
export const ToastMessage = _ToastMessage;
export const EnableControlVersion = _enableControlVersion;
export const ControlVersion = _controlVersion;

export const ReactServices = (options?: {
  ToastServiceOptions?: ToastOptions | undefined;
  IndicatorServiceOptions?: IndicatorOptions | undefined;
  VersionControlServiceOptions?: VersionControlOptions | undefined;
}) => {
  return (
    <>
      <ToastService {...options?.ToastServiceOptions} />
      <IndicatorService {...options?.IndicatorServiceOptions} />
      <VersionControlService {...options?.VersionControlServiceOptions} />
    </>
  );
};
